import UAParser from "ua-parser-js";
import { DvcDetails } from "../types";

export const getDvcDetails = (): DvcDetails => {
  const parsedUA = UAParser();
  return {
    model: parsedUA.device.model || "",
    make: parsedUA.device.vendor || "",
    os: `${parsedUA.os.name} ${parsedUA.os.version}`,
    browser: `${parsedUA.browser.name} ${parsedUA.browser.version}`,
  };
};
